import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/testimonials`);
        setTestimonials(response.data);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading || testimonials.length === 0) {
    return null;
  }

  return (
    <section data-testid="testimonials-section" className="py-24 px-6 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-['Oswald'] text-3xl sm:text-4xl md:text-5xl text-[#F2EDE6] mb-4">
            FROM THE RALLY FAMILY
          </h2>
          <p className="text-[#A19D98]">
            Don't take our word for it—hear from those who've been on the road with us.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, i) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-[#141414] border border-[#2A2A2A] p-8 relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#E8651A]/20" />
              
              <p className="text-[#F2EDE6] text-lg leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>
              
              <div className="border-t border-[#2A2A2A] pt-4">
                <p className="font-['Oswald'] text-[#F2EDE6] text-lg">
                  {testimonial.name}
                </p>
                {testimonial.car && (
                  <p className="text-[#A19D98] text-sm">
                    {testimonial.car}
                  </p>
                )}
                {testimonial.rally && (
                  <p className="text-[#E8651A] text-xs mt-1">
                    {testimonial.rally}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
